export default __webpack_public_path__ + "static/media/present.24c2eac6.svg";